// Dashboard data comes from GET /admin/dashboard-overview.
// This file only holds the brand colours and the small helpers that shape the API response for the UI.
import moment from "moment";

export const BRAND = {
  red: "#EA352B",
  redSoft: "#FDECEA",
  orange: "#FF8A3D",
  amber: "#F5B400",
  dark: "#1B1B22",
  green: "#16A34A",
  blue: "#2563EB",
  muted: "#8A8F98",
};

// Customers may add up to this many vehicles for free; beyond it they must subscribe.
// The API sends the real limit (insight.freeVehicleLimit); this is only the fallback.
export const FREE_VEHICLE_LIMIT = 2;

export const BOOKING_STATUSES = ["Pending", "In Chat", "Completed", "Rejected"];

export const EMPTY_STATUS_COUNTS = { Pending: 0, "In Chat": 0, Completed: 0, Rejected: 0 };

// Lists from the API carry no colours, so they're assigned by rank.
const PALETTE = [BRAND.red, BRAND.orange, BRAND.amber, BRAND.dark, "#4B5563", "#6B7280", "#9CA3AF", "#B8BCC6", "#D1D5DB"];
export const colorAt = (i) => PALETTE[i % PALETTE.length];

export const PLAN_COLORS = [BRAND.red, BRAND.orange, BRAND.amber];
export const FREE_SPLIT_COLOR = "#E9E9EE";

export const carLabel = (car) => [car.vehicleMake, car.vehicleModel, car.vehicleYear].filter(Boolean).join(" ") || "Vehicle not set";
export const plateLabel = (car) => [car.plateSource, car.plateCode, car.plate].filter(Boolean).join(" ") || "No plate";

const dateTime = (value) => (value ? moment(value).format("D MMM, h:mm A") : null);

// API dates are ISO strings; the dialogs render the text as-is.
export const normalizeBooking = (booking) => ({
  ...booking,
  timeline: booking.timeline.map((t) => ({ ...t, time: dateTime(t.time) })),
  chat: booking.chat.map((m) => ({ ...m, time: dateTime(m.time) })),
});

export const normalizeShop = (shop) => ({
  ...shop,
  createdAt: shop.createdAt ? moment(shop.createdAt).format("DD MMM YYYY") : "—",
});
